import React from "react";
import { IoMdSearch } from "react-icons/io";

const SidebarSearchInput = ({ value, onChange, onClear, onKeyDown }) => (
  <div className="sidebar-search__input-wrapper">
    <div className="sidebar-search__field">
      <IoMdSearch className="sidebar-search__icon" size={18} />
      <input
        type="text"
        className="sidebar-search__input"
        placeholder="Search ..."
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        autoComplete="off"
        aria-label="Search sidebar"
      />
      {value && (
        <button
          type="button"
          className="sidebar-search__clear"
          onClick={onClear}
          aria-label="Clear search"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  </div>
);

export default SidebarSearchInput;
